import { all, call, put, takeLatest } from 'redux-saga/effects'
import agent, { mocked } from '../../agent'
import appMode from 'helpers/getAppMode'
import * as actions from '../actions/locales.actions'

function* getLocalesSaga() {
  try {
    let endpoint = agent.KeywordFinder.getLocales
    if (appMode.preview) {
      endpoint = mocked.KeywordFinder.getLocales
    }

    const body = yield call(endpoint)
    const data = body.data.map(item => item.attributes)
    yield put(actions.getLocalesSuccess(data))
  } catch (error) {
    yield put(actions.getLocalesFailure(error))
  }
}

export default function* localesSagas() {
  yield all([
    takeLatest(actions.getLocales.type, getLocalesSaga)
  ])
}
